<template>
	<div>
		<Modal class="InputDisable" v-model="modal.ifShow" :title="modal.Title" width="50%" :mask-closable="false"
			:closable="true">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='view'||modal.type=='up'" ref="refForm"
				:model="modalInfo" :label-width="110">
				<!--放置不需要添加的属性 -->
				<Row :gutter="24">
					<Col span="12">
						<FormItem label="当前状态" prop="StatusDesc">
							<Input :disabled="modal.canInput" v-model="modalInfo.StatusDesc" placeholder="当前状态"></Input>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="处理评价" prop="RepairEvaluate">
							<Input :disabled="modal.canInput" v-model="modalInfo.RepairEvaluate"
								placeholder="处理评价"></Input>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span="12">
					<Row v-show="false" :gutter="24">
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="报修时间" prop="ApplyTime">
							<Input :disabled="modal.canInput" v-model="modalInfo.ApplyTime" placeholder="报修时间"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="报修来源" prop="ApplySourceDesc">
							<Input :disabled="modal.canInput" v-model="modalInfo.ApplySourceDesc"
								placeholder="报修来源"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="报修账号" prop="ApplyMemberId">
							<Input :disabled="modal.canInput" v-model="modalInfo.ApplyMemberId"
								placeholder="报修账号"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="报修人姓名" prop="ApplyUserName">
							<Input :disabled="modal.canInput" v-model="modalInfo.ApplyUserName"
								placeholder="报修人姓名"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="故障站点" prop="StationName">
							<Input :disabled="modal.canInput" v-model="modalInfo.StationName"
								placeholder="故障站点"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="故障桩编号" prop="EquipmentNo">
							<Input :disabled="modal.canInput" v-model="modalInfo.EquipmentNo"
								placeholder="故障桩编号"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="故障分类" prop="FaultTypeDesc">
							<Input :disabled="modal.canInput" v-model="modalInfo.FaultTypeDesc"
								placeholder="故障分类"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="故障描述" prop="FaultDesc">
							<Input :disabled="modal.canInput" v-model="modalInfo.FaultDesc" placeholder="故障描述"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="故障图片" prop="FaultPicturesArray">
							<div class="demo-upload-list" :key="itemIndex"
								v-for="(item,itemIndex) in modalInfo.FaultPicturesArray">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
								</div>
							</div>
							<Upload v-if="modalInfo.FaultPicturesArray == 0" ref="upload" :disabled="true"
								:show-upload-list="false" multiple type="drag"
								style="display: inline-block;width:58px;">
								<div style="width: 58px;height:58px;line-height: 58px;">
									<!-- <Icon type="ios-camera" size="20"></Icon> -->
								</div>
							</Upload>
							<Modal title="View Image" v-model="visible"  width="75">
								<img :src="imgName" v-if="visible" style="width: 100%">
							</Modal>
						</FormItem>
						</Col>
					</Row>
					</Col>
					<Col span="12">
					<!-- ------------------------维修信息 -------------------- -->
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修说明" prop="RepairDesc">
							<Input :disabled="modal.canInput" v-model="modalInfo.RepairDesc" placeholder="维修说明"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修详细信息" prop="RepairDetail">
							<Input :disabled="modal.canInput" v-model="modalInfo.RepairDetail"
								placeholder="维修详细信息"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修人" prop="RepairUserName">
							<Input :disabled="modal.canInput" v-model="modalInfo.RepairUserName"
								placeholder="维修人"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修开始时间" prop="RepairBeginTime">
							<Input :disabled="modal.canInput" v-model="modalInfo.RepairBeginTime"
								placeholder="维修开始时间"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修结束时间" prop="RqpairEndTime">
							<Input :disabled="modal.canInput" v-model="modalInfo.RqpairEndTime"
								placeholder="维修结束时间"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=24>
						<FormItem label="维修图片" prop="RepairPicturesArray">
							<div class="demo-upload-list" :key="itemIndex"
								v-for="(item,itemIndex) in modalInfo.RepairPicturesArray">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
								</div>
							</div>
							<Upload v-if="modalInfo.RepairPicturesArray == 0" ref="upload" :disabled="true"
								:show-upload-list="false" multiple type="drag"
								style="display: inline-block;width:58px;">
								<div style="width: 58px;height:58px;line-height: 58px;">
									<!-- <Icon type="ios-camera" size="20"></Icon> -->
								</div>
							</Upload>
							<Modal title="View Image" v-model="visible"  width="75">
								<img :src="imgName" v-if="visible" style="width: 100%">
							</Modal>
						</FormItem>
						</Col>
					</Row>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='view'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">关闭</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			
			return {
				modal: {
					Title: "用户添加",
					type: "add",
					ifShow: false,
					canInput: true
				},
				
				modalInfo: {
					// Id
					// 控件名称
					// 显示名
					// 控件描述
					// 控件图标
					// 是否删除
					// 控件类型
					// 是否为警告操作
					// 排序
					"Id": 0,
					"Name": "",
					"Display": "",
					"Desc": "",
					"Icon": "fas fa-search",
					"IsDeleted": 0,
					"WidgetType": 0,
					"Sort": 1,
					"IsDanger": 0,
					"ModifyBy": -2,
					"ModifyTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,

				/****************/
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Name: [{
						required: true,
						message: '控件名称',
						trigger: 'blur'
					}],
					Display: [{
						required: true,
						message: '显示名称',
						trigger: 'blur'
					}],
					Icon: [{
						required: true,
						message: '图标',
						trigger: 'blur',
					}],
				},
			};
		},

		methods: {
			
			show: function(type, params) {
				const _this = this;
				if (type == "view") {
					_this.modal.Title = "报修单详情";
					_this.modal.type = "view";
					// _this.modalInfo = {
					// 	Id: params.Id,
					// 	StationId: params.StationId,
					// 	EquipmentModel: params.EquipmentModel,
					// 	ConnectorNo: params.ConnectorNo,
					// 	FaultType: params.FaultType,
					// 	FaultTypeDesc: params.FaultTypeDesc,
					// 	FaultCode: params.FaultCode,
					// 	FaultDesc: params.FaultDesc,
					// 	FaultDetail: params.FaultDetail,
					// 	FaultPicturesArray: params.FaultPicturesArray.length == 0 ? [] : params.FaultPicturesArray.map(obj => {
					// 		return {
					// 			value: obj,
					// 			url: webapi.base_api_url + obj
					// 		}
					// 	}),
					// 	// FaultPicturesArray: ['111', '222'],
					// 	ApplyUser: params.ApplyUser,
					// 	ApplyUserName: params.ApplyUserName,
					// 	ApplyTime: params.ApplyTime,
					// 	ApplySource: params.ApplySource,
					// 	ApplySourceDesc: params.ApplySourceDesc,
					// 	RepairDesc: params.RepairDesc,
					// 	RepairDetail: params.RepairDetail,
					// 	RepairPictures: params.RepairPictures,
					// 	RepairPicturesArray: params.RepairPicturesArray.length == 0 ? [] : params.RepairPicturesArray.map(obj => {
					// 		return {
					// 			value: obj,
					// 			url: webapi.base_api_url + obj
					// 		}
					// 	}),
					// 	RepairUser: params.RepairUser,
					// 	RepairBeginTime: params.RepairBeginTime,
					// 	RqpairEndTime: params.RqpairEndTime,
					// 	AuditResult: params.AuditResult,
					// 	AuditUser: params.AuditUser,
					// 	AuditTime: params.AuditTime,
					// 	Status: params.Status,
					// 	StatusDesc: params.StatusDesc,
					// 	RepairEvaluate: params.RepairEvaluate,
					// 	UserPhone: params.UserPhone
					// };
					const info = {
						...params,
						FaultPicturesArray: params.FaultPicturesArray.length == 0 ? [] : params.FaultPicturesArray
							.map(obj => {
								return {
									value: obj,
									url: webapi.base_api_url + obj
								}
							}),
						RepairPicturesArray: params.RepairPicturesArray.length == 0 ? [] : params
							.RepairPicturesArray.map(obj => {
								return {
									value: obj,
									url: webapi.base_api_url + obj
								}
							}),
					};
					_this.modalInfo = info;
					console.log('modalInfo', _this.modalInfo);
				}
				_this.modal.ifShow = true
			},

			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			
			addAndUp: function(type) {

				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("控件" + type + "----" + valid)
					if (valid) {
						let parms = _this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/System/AddSysWidget", parms, {}).then(
							res => {
								console.log("Add")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success(this.$t('Common.AddSuccess'));
									_this.$emit('handleSubmit');
									_this.modalOk("cancle")
								} else {
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},

			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
		
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			}),
		}
	}
</script>

<style>
	.InputDisable .ivu-input[disabled],
	fieldset[disabled] .ivu-input {
		background-color: #cccccc !important;
		opacity: 0.5;
		cursor: not-allowed;
		color: #000000;
		font-weight: bold;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
